import script from "./userInsertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./userInsertModal.vue?vue&type=script&setup=true&lang=js"

import "./userInsertModal.vue?vue&type=style&index=0&id=22b214da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b214da"]])

export default __exports__